import { z } from 'zod';

const schema = z
  .object({
    // Client + Server
    NEXT_PUBLIC_GA_ID: z.string().min(1),
    NEXT_PUBLIC_APP_NAME: z.string().min(1),
    NEXT_PUBLIC_DESCRIPTION: z.string().min(1).optional(),
    NEXT_PUBLIC_CONTACT_EMAIL: z.string().email().optional(),
    NEXT_PUBLIC_PORTFOLIO_OWNER: z.string().min(1),
    NEXT_PUBLIC_PORTFOLIO_SLOGAN: z.string().min(1).optional(),
    NEXT_PUBLIC_PORTFOLIO_SLOGAN_LONG: z.string().min(1).optional(),
    NEXT_PUBLIC_FRONTEND_URL: z.string().url(),
    NEXT_PUBLIC_X_HANDLER: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_VERFICATION_CODE: z.string().min(1),
    NEXT_PUBLIC_YANDEX_VERFICATION_CODE: z.string().min(1),
    NEXT_PUBLIC_YAHOO_VERFICATION_CODE: z.string().min(1),
    NEXT_PUBLIC_GUMROAD_PRODUCT_URL: z.string().url(),
    NEXT_PUBLIC_BUYMEACOFFEE_PRODUCT_URL: z.string().min(1),

    // Server only
    SMTP_HOST: z.string().min(1).optional(),
    SMTP_PORT: z.string().regex(/^\d+$/).optional(),
    SMTP_USER: z.string().min(1).optional(),
    SMTP_PASSWORD: z.string().min(1).optional(),
    SMTP_CONTACT_EMAIL: z.string().email().optional(),
  })
  .partial()
  .strict();

export const environment = schema.parse({
  NEXT_PUBLIC_GA_ID: process.env.NEXT_PUBLIC_GA_ID,
  NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
  NEXT_PUBLIC_DESCRIPTION: process.env.NEXT_PUBLIC_DESCRIPTION,
  NEXT_PUBLIC_CONTACT_EMAIL: process.env.NEXT_PUBLIC_CONTACT_EMAIL,
  NEXT_PUBLIC_PORTFOLIO_OWNER: process.env.NEXT_PUBLIC_PORTFOLIO_OWNER,
  NEXT_PUBLIC_PORTFOLIO_SLOGAN: process.env.NEXT_PUBLIC_PORTFOLIO_SLOGAN,
  NEXT_PUBLIC_PORTFOLIO_SLOGAN_LONG:
    process.env.NEXT_PUBLIC_PORTFOLIO_SLOGAN_LONG,
  NEXT_PUBLIC_FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL,
  NEXT_PUBLIC_X_HANDLER: process.env.NEXT_PUBLIC_X_HANDLER,
  NEXT_PUBLIC_GOOGLE_VERFICATION_CODE:
    process.env.NEXT_PUBLIC_GOOGLE_VERFICATION_CODE,
  NEXT_PUBLIC_YANDEX_VERFICATION_CODE:
    process.env.NEXT_PUBLIC_YANDEX_VERFICATION_CODE,
  NEXT_PUBLIC_YAHOO_VERFICATION_CODE:
    process.env.NEXT_PUBLIC_YAHOO_VERFICATION_CODE,
  NEXT_PUBLIC_GUMROAD_PRODUCT_URL: process.env.NEXT_PUBLIC_GUMROAD_PRODUCT_URL,
  NEXT_PUBLIC_BUYMEACOFFEE_PRODUCT_URL:
    process.env.NEXT_PUBLIC_BUYMEACOFFEE_PRODUCT_URL,

  // Server only
  SMTP_HOST: process.env.SMTP_HOST,
  SMTP_PORT: process.env.SMTP_PORT,
  SMTP_USER: process.env.SMTP_USER,
  SMTP_PASSWORD: process.env.SMTP_PASSWORD,
  SMTP_CONTACT_EMAIL: process.env.SMTP_CONTACT_EMAIL,
});
